import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FieldErrorDynamicStyleConstantType,
    FieldErrorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const FIELD_ERROR_VARIANT: keyof NCoreUIKit.Typography = "bodyMediumSize";

export const FIELD_ERROR_BULLET = "•";

const stylesheet = StyleSheet.create({
    row: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    icon: {
        justifyContent: "center"
    },
    container: {
        flexDirection: "column"
    },
    message: {
        flexShrink: 1
    }
});

export const useStyles = ({
    typography,
    spaces
}: FieldErrorDynamicStyleConstantType): FieldErrorDynamicStyleType => {
    return {
        icon: {
            height: typography[FIELD_ERROR_VARIANT].lineHeight
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        row: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };
};
export default stylesheet;
